import { useCallback, useEffect, useMemo, useState } from 'react';
import {API, TagsAPI} from '@brg/api';
import moment from 'moment';
import {useDeepCompareEffect} from "../../utils/useDeepCompareEffect";
import {usePrevious} from "../../utils/usePrevious";
import urlApi from 'shared/actions/urlApi';

const createHash = (string: string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const useCachedResponse = (args: any, shouldCacheValues?: boolean) => {
    const [responseTable, setResponseTable] = useState({})

    const setResponse = useCallback((response: any) => {
        const hash = createHash(JSON.stringify(args));
        setResponseTable({
            ...responseTable,
            [hash]: {
                response,
                args,
                time: Date.now(),
            }
        })
    }, [responseTable, args]);

    const cachedValue = useMemo(() => {
        if (shouldCacheValues) {
            const hash = createHash(JSON.stringify(args));
            //@ts-ignore
            if (responseTable[hash] && moment().diff(responseTable[hash].time) < 1000 * 1000 * 5) {
                //@ts-ignore
                return responseTable[hash].response;
            }
        }
    }, [args])

    return [cachedValue, setResponse]
}

export const useGetApiTags = (
    filter: any,
    lang = 'en',
    t?: number,
    disabled?: boolean,
    appContext?: string
) => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState(null);
    const [raw, setRaw] = useState<unknown>();
    const [loadedHash, setLoadedHash] = useState<unknown>();
    const [cachedResponse, setCachedResponse] = useCachedResponse(filter, true);
    const propHash = useMemo(() => {
        return createHash(JSON.stringify(filter))
    }, [filter])
    const prevFilter = usePrevious(disabled ? undefined : filter);
    const [isFetching, setIsFetching] = useState(false);

    const sortTags = useCallback((tags: any[]) => {
        if (!tags || !Array.isArray(tags)) return tags;
        
        return tags.sort((a, b) => {
            if (a.isHeader && !b.isHeader) return -1;
            if (!a.isHeader && b.isHeader) return 1;
            
            return a.name?.localeCompare(b.name);
        });
    }, []);

    useDeepCompareEffect(() => {
        if (JSON.stringify(prevFilter) === JSON.stringify(filter)) {
            return;
        }
        if (disabled) {
            return
        }

        setResponse(null)

        if (cachedResponse) {
            setLoadedHash(createHash(JSON.stringify(filter)));
            setRaw(cachedResponse);
            return;
        }

        setIsLoading(true);
        setIsFetching(true);

        if (!!appContext) {
            urlApi()?.fetchTagsTree(filter, appContext ?? '')
                ?.then(({ data }) => {
                    setCachedResponse(data);
                    setRaw(data)
                    setLoadedHash(createHash(JSON.stringify(filter)))
                })
                .catch((reason) => setError(reason))
                .finally(() => {
                    setIsFetching(false);
                });
        } else {
            TagsAPI.GetTagsTree(filter)
            .then((value) => value.json())
            .then((value) => {
                setCachedResponse(value);
                setRaw(value)
                setLoadedHash(createHash(JSON.stringify(filter)))
            })
            .catch((reason) => setError(reason))
            .finally(() => {
                setIsFetching(false);
            });
        }

    }, [t, disabled, filter, cachedResponse, sortTags,setCachedResponse]);

    useEffect(() => {
        if (raw) {
            setError(undefined);
            setResponse(API.toLang(raw, lang) as any);
        }
    }, [raw, lang]);

    useEffect(() => {
        if (disabled) {
            setIsLoading(false);
            return;
        }

        if (error) {
            setIsLoading(false);
            return;
        }

        if (isFetching) {
            setIsLoading(true);
            return;
        }

        if (propHash === loadedHash && response !== null) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
    }, [response, raw, error, propHash, loadedHash, cachedResponse, disabled, isFetching]);

    const preparedResponse = useMemo(() => {
        return response === null ? [] : response
    }, [response]);

    return [preparedResponse, isLoading, error];
}import { useCallback, useEffect, useMemo, useState } from 'react';
import {API, TagsAPI} from '@brg/api';
import moment from 'moment';
import {useDeepCompareEffect} from "../../utils/useDeepCompareEffect";
import {usePrevious} from "../../utils/usePrevious";
import urlApi from 'shared/actions/urlApi';

const createHash = (string: string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const useCachedResponse = (args: any, shouldCacheValues?: boolean) => {
    const [responseTable, setResponseTable] = useState({})

    const setResponse = useCallback((response: any) => {
        const hash = createHash(JSON.stringify(args));
        setResponseTable({
            ...responseTable,
            [hash]: {
                response,
                args,
                time: Date.now(),
            }
        })
    }, [responseTable, args]);

    const cachedValue = useMemo(() => {
        if (shouldCacheValues) {
            const hash = createHash(JSON.stringify(args));
            //@ts-ignore
            if (responseTable[hash] && moment().diff(responseTable[hash].time) < 1000 * 1000 * 5) {
                //@ts-ignore
                return responseTable[hash].response;
            }
        }
    }, [args])

    return [cachedValue, setResponse]
}

export const useGetApiTags = (
    filter: any,
    lang = 'en',
    t?: number,
    disabled?: boolean,
    appContext?: string
) => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState(null);
    const [raw, setRaw] = useState<unknown>();
    const [loadedHash, setLoadedHash] = useState<unknown>();
    const [cachedResponse, setCachedResponse] = useCachedResponse(filter, true);
    const propHash = useMemo(() => {
        return createHash(JSON.stringify(filter))
    }, [filter])
    const prevFilter = usePrevious(disabled ? undefined : filter);
    const [isFetching, setIsFetching] = useState(false);

    const sortTags = useCallback((tags: any[]) => {
        if (!tags || !Array.isArray(tags)) return tags;
        
        return tags.sort((a, b) => {
            if (a.isHeader && !b.isHeader) return -1;
            if (!a.isHeader && b.isHeader) return 1;
            
            return a.name?.localeCompare(b.name);
        });
    }, []);

    useDeepCompareEffect(() => {
        if (JSON.stringify(prevFilter) === JSON.stringify(filter)) {
            return;
        }
        if (disabled) {
            return
        }

        setResponse(null)

        if (cachedResponse) {
            setLoadedHash(createHash(JSON.stringify(filter)));
            setRaw(cachedResponse);
            return;
        }

        setIsLoading(true);
        setIsFetching(true);

        if (!!appContext) {
            urlApi()?.fetchTagsTree(filter, appContext ?? '')
                ?.then(({ data }) => {
                    setCachedResponse(data);
                    setRaw(data)
                    setLoadedHash(createHash(JSON.stringify(filter)))
                })
                .catch((reason) => setError(reason))
                .finally(() => {
                    setIsFetching(false);
                });
        } else {
            TagsAPI.GetTagsTree(filter)
            .then((value) => value.json())
            .then((value) => {
                setCachedResponse(value);
                setRaw(value)
                setLoadedHash(createHash(JSON.stringify(filter)))
            })
            .catch((reason) => setError(reason))
            .finally(() => {
                setIsFetching(false);
            });
        }

    }, [t, disabled, filter, cachedResponse, sortTags,setCachedResponse]);

    useEffect(() => {
        if (raw) {
            setError(undefined);
            setResponse(API.toLang(raw, lang) as any);
        }
    }, [raw, lang]);

    useEffect(() => {
        if (disabled) {
            setIsLoading(false);
            return;
        }

        if (error) {
            setIsLoading(false);
            return;
        }

        if (isFetching) {
            setIsLoading(true);
            return;
        }

        if (propHash === loadedHash && response !== null) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
    }, [response, raw, error, propHash, loadedHash, cachedResponse, disabled, isFetching]);

    const preparedResponse = useMemo(() => {
        return response === null ? [] : response
    }, [response]);

    return [preparedResponse, isLoading, error];
}